import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import profile from './modules/profile';
import staff from './modules/staff';
import metrics from './modules/metrics';
import requests from './modules/requests';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    auth,
    profile,
    staff,
    metrics,
    requests,
  },
});
